import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Boton } from "../components/Boton";
import { Campo, Input } from "../components/Formulario";
import { Tarjeta } from "../components/Tarjeta";
import { api, ErrorApi } from "../lib/apiClient";
import { useAuth } from "./AuthContext";

export function CambiarPasswordPage() {
  const { usuario, recargarUsuario } = useAuth();
  const navegar = useNavigate();
  const [passwordActual, setPasswordActual] = useState("");
  const [passwordNueva, setPasswordNueva] = useState("");
  const [passwordConfirmar, setPasswordConfirmar] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (usuario && !usuario.debe_cambiar_password) {
    return <Navigate to="/dashboard" replace />;
  }

  async function manejarEnvio(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (passwordNueva !== passwordConfirmar) {
      setError("La confirmación no coincide con la contraseña nueva.");
      return;
    }
    setEnviando(true);
    try {
      await api.patch("/auth/cambiar-password", {
        password_actual: passwordActual,
        password_nueva: passwordNueva,
      });
      await recargarUsuario();
      navegar("/dashboard", { replace: true });
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : "No se pudo cambiar la contraseña. Intentá nuevamente.");
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-fondo px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-principal text-lg font-semibold text-superficie">
            J
          </div>
          <h1 className="text-lg font-semibold text-texto">Cambiá tu contraseña</h1>
          <p className="mt-1 text-sm text-texto-secundario">
            Por seguridad, necesitás definir una contraseña nueva antes de continuar.
          </p>
        </div>
        <Tarjeta tamano="grande">
          <form onSubmit={manejarEnvio}>
            <div className="space-y-4">
              <Campo etiqueta="Contraseña actual" obligatorio>
                <Input
                  type="password"
                  autoComplete="current-password"
                  required
                  value={passwordActual}
                  onChange={(e) => setPasswordActual(e.target.value)}
                />
              </Campo>
              <Campo etiqueta="Contraseña nueva" obligatorio>
                <Input
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={passwordNueva}
                  onChange={(e) => setPasswordNueva(e.target.value)}
                  placeholder="Mínimo 8 caracteres"
                />
              </Campo>
              <Campo etiqueta="Confirmar contraseña nueva" obligatorio>
                <Input
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={passwordConfirmar}
                  onChange={(e) => setPasswordConfirmar(e.target.value)}
                />
              </Campo>
            </div>
            {error && <div className="mt-4 rounded-lg bg-error/10 px-3 py-2 text-sm font-medium text-error">{error}</div>}
            <Boton type="submit" cargando={enviando} className="mt-5 w-full">
              Cambiar contraseña
            </Boton>
          </form>
        </Tarjeta>
      </div>
    </div>
  );
}
